import { Palette } from 'config';
import styled from 'styled-components';

export const Separator = styled.div`
  gap: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0px 10px;
  background-color: ${Palette.PrimaryGray._200};
  min-height: 1px;
`;
export const FlexRow11 = styled.div`
  gap: 8px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
`;
export const SelectedItem = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  border-width: 1px;
  border-radius: 4px;
  border-style: solid;
  border-color: ${Palette.PrimaryGray._200};
  background-color: #ffffff;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
  padding: 0px 2px 0 0;
`;

export const FlexRow2 = styled.div`
  gap: 8px;
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 8px;
`;

export const Label10 = styled.div`
  width: 145px;
  flex-grow: 1;
  color: ${Palette.PrimaryGray._700};
  font-size: 12px;
  font-family: Roboto;
  line-height: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  p {
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
  }
`;

export const MultipleItemsSelectionComponent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 8px;

  border: ${({ showBorder }) => showBorder && `1px solid ${Palette.Red._300}`};
  background-color: #f8fafc;
  box-shadow: inset 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
  overflow: hidden;
`;
export const FlexColumn3 = styled.div`
  gap: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 16px;
`;

export const SelectedItems = styled.div`
  gap: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 16px;
`;

export const SelectedItemsList = styled.div`
  width: 100%;
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(3, minmax(190px, 1fr));
`;
